﻿document.addEventListener('DOMContentLoaded', () => {
    const $navbar = document.getElementById('navbar');
    const $hamburger = document.getElementById('navbar-burger');

    if ($navbar) {
        document.addEventListener('scroll', () => {
            if (window.scrollY === 0) {
                $navbar.classList.add('is-spaced');
            } else {
                $navbar.classList.remove('is-spaced');
            }
        });
    }

    if ($hamburger) {
        const $hamburgerText = $hamburger.querySelector('.hamburger-text');

        const updateHamburgerText = () => {
            if ($hamburger.classList.contains('is-active')) {
                $hamburgerText.textContent = $hamburger.dataset.closeHamburgerText;
            } else {
                $hamburgerText.textContent = $hamburger.dataset.hamburgerText;
            }
        };

        updateHamburgerText();

        const observer = new MutationObserver(() => {
            updateHamburgerText();
        });

        observer.observe($hamburger, { attributes: true, attributeFilter: ['class'] });
    }
});
